import { useEffect } from "react";
import { useCMS } from "../lib/cms";

const SEO_DEFAULTS = {
  title: "West London Stays — Luxury Studios in Hammersmith, W6",
  description: "A boutique studio in Hammersmith for short, medium and long stays. Live in London — not just visit. Book direct.",
  og_image: "/brand/wls-og.jpg",
  keywords: "west london stays, hammersmith studio, long stay london, serviced apartment london",
};

function setMeta(selector, attr, value) {
  if (!value) return;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const m = selector.match(/\[(\w+)="([^"]+)"\]/);
    if (m) el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

/**
 * Renders nothing — declaratively updates document.title + meta tags from CMS.
 * Runs whenever the SEO section changes. Used once at the top of the app.
 */
export default function SEOHead() {
  const seo = useCMS("seo", SEO_DEFAULTS);

  useEffect(() => {
    if (seo.title) document.title = seo.title;
    setMeta('meta[name="description"]', "content", seo.description);
    setMeta('meta[property="og:title"]', "content", seo.title);
    setMeta('meta[property="og:description"]', "content", seo.description);
    setMeta('meta[property="og:image"]', "content", seo.og_image);
    setMeta('meta[name="twitter:title"]', "content", seo.title);
    setMeta('meta[name="twitter:description"]', "content", seo.description);
    setMeta('meta[name="twitter:image"]', "content", seo.og_image);
    setMeta('meta[name="keywords"]', "content", seo.keywords);
  }, [seo.title, seo.description, seo.og_image, seo.keywords]);

  return null;
}
